import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admission-helpline',
  templateUrl: './admission-helpline.component.html',
  styleUrls: ['./admission-helpline.component.scss']
})
export class AdmissionHelplineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
